<template>
  <b-modal id="taxpayer-det" ref="modal" size="lg" title="Detail" @show="setData" >
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Taxpayer ID Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.number_npwp}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "TaxPayerDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        name:"",
        number_npwp:"",
        registered_date:"",
        desc:"",
        status:"",
        last_modified:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.detail={
            name:this.data.name,
            number_npwp:this.data.npwp_number,
            registered_date:this.data.registered_date,
            desc:this.data.desc,
            status:this.data.status == 1 ? "Active" : "Not Active",
            last_modified: this.data.last_modified
          }
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.$refs.modal.hide()
    }
  }
}
</script>